export default "__VITE_ASSET__5531e8b5__"